export var CookieCategory = /*#__PURE__*/function (CookieCategory) {
  CookieCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
  CookieCategory["Functional"] = "FUNCTIONAL";
  CookieCategory["Marketing"] = "MARKETING";
  CookieCategory["Analytics"] = "ANALYTICS";
  CookieCategory["Unknown"] = "UNKNOWN";
  return CookieCategory;
}({});
export var ConsentPreference = /*#__PURE__*/function (ConsentPreference) {
  ConsentPreference["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
  ConsentPreference["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
  ConsentPreference["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
  ConsentPreference["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
  ConsentPreference["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
  return ConsentPreference;
}({});
export var PrefetchedPreferenceState = /*#__PURE__*/function (PrefetchedPreferenceState) {
  PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
  return PrefetchedPreferenceState;
}({});